/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
/*jslint latedef:false*/
'use strict';

angular.module('bulbApp.compositeViewModule')
.directive('bulbCompositeView', ['$log','$state','$window','Foundation', bulbCompositeView]);

function bulbCompositeView($log, $state, $window, Foundation) {
  return {
    restrict: 'E',
    templateUrl: 'ajs/components/compositeview/compositeview.html',
    controller: 'CompositeViewController as compositeViewCtrl',
    bindToController: {
      compositeUnit: '='
    },
    scope: true,
    transclude: true,
    link: function(scope, element, attrs) {
      var compositeViewCtrl = scope.compositeViewCtrl;

      element.attr('viewtype', compositeViewCtrl.viewType);

      element.addClass('bulb-accent' + compositeViewCtrl.compositeUnit.accentIndex);

      // TODO CLEAN : this cover image code is virtually identical to the cover image code in
      // pageview-directive.js and needs to be pulled out into a directive of its own so we don't have
      // duplicate code to maintain.

      var minCoverImageTotalHeight = 500;

      // This represents a buffer so that the header banner doesn't overlay the 'edit image' button for the
      // cover image.  It is paralleled by css so modifications should be made in both places.
      // FUTURE : use a mechanism to share duplicated information between SASS and JS.
      var editImageBuffer = 47;

      var jqWindow = jQuery($window);

      if (!Foundation.utils.is_large_up()) {  // jshint ignore:line
        // NOTE : this represents the utilization of 33% of the browser height on mobile devices.  It is
        // duplicated in the scss for 'bulb-has-cover-image' and in imeageeditor-directive.js, so changing
        // it here should change it there as well.
        // FUTURE: Should consider a mechanism to share duplicated information between SASS and JS.
        minCoverImageTotalHeight = jqWindow.height() / 3;
      }

      var coverImage;

      // Check if its redirected from authentication after user liked collection.
      var isAuthorized = '';
      try {
        isAuthorized = localStorage.getItem('isAuthorized');
      } catch (error) {
        $state.go('blockingAccess', { error: error.message });
      }

      if (isAuthorized === 'isAuthorized') {
        compositeViewCtrl.toggleRecommend();
      }

      // Lay out the cover image, based on its width and height.
      var setCoverImage = function() {
        if (coverImage) {
          var windowWidth = jqWindow.width();
          var scale;
          // default values for width, height, left, and top are '',
          // which jQuery.css interprets as "remove style".
          var width = '';
          var height = '';
          var left = '';
          var top = '';
          scope.style = '';

          var bannerHeight = jQuery('.bulb-cover-image-banner').height();
          var coverImageTotalHeight = Math.max(minCoverImageTotalHeight, bannerHeight + editImageBuffer);

          var imageAspectRatio = coverImage.width / coverImage.height;
          var headerAspectRatio = windowWidth / coverImageTotalHeight;
          if (imageAspectRatio > headerAspectRatio) {
            // image wider than header: scale image height to header height, and center horizontally
            height = coverImageTotalHeight;
            scale = height / coverImage.height;
            left = (windowWidth - scale * coverImage.width) / 2;
          } else {
            // header wider than image: scale image width to header width, and center vertically
            width = windowWidth;
            scale = width / coverImage.width;
            top = (coverImageTotalHeight - scale * coverImage.height) / 2;
          }
          var style = {
            width: width,
            height: height,
            top: top,
            left: left
          };

          $log.debug('bulbCompositeView: setCoverImage: window width): ' + windowWidth + ' style: ' +
            JSON.stringify(style, null, 2));
          var coverImageElement = jQuery('.bulb-cover-image');
          coverImageElement.css(style);
          scope.style = style;
        }
      };

      // Style the mock content wrapper:
      // If the contentWrapper is visible, set the mock content wrapper's height.
      // Set its width to the width of the cropper, and center it.
      var setEditorContent = function() {
        // TODO CLEAN : this mock banner doesn't necessarily match real content anyways, so we could just
        // hard code a height, and get rid of this code to simplify things
        var contentWrapperHeight;

        var contentWrapper = jQuery('.bulb-composite-header-unit-content-wrapper');
        var cropper = jQuery('.cropper-container');
        var editorContent = jQuery('.bulb-composite-header-image-editor-content');
        var style = {};
        if (contentWrapper.length > 0) {
          contentWrapperHeight = contentWrapper.height();
        }
        if (editorContent.length > 0) {
          if (cropper.length > 0) {
            style.width = cropper.width();
            style.left = '50%';
            style.marginLeft = -(cropper.width() / 2);
          } else {
            style.width = '';
            style.left = 0;
            style.marginLeft = 0;
          }
          if (contentWrapperHeight) {
            style.height = contentWrapperHeight;
          }
          editorContent.css(style);
        }
      };

      var onResize = function(event) {
        if (compositeViewCtrl.mode === 'editor') {
          setEditorContent();
        } else if (compositeViewCtrl.compositeUnit.coverImage) {
          setCoverImage();
        }
      };

      // Rescale cover image on window resize.
      jqWindow.on('resize', onResize);

      // Watch for height changes of the header banner, and adjust the cover image when they happen.
      scope.$watch(function () {
        return jQuery('.bulb-cover-image-banner').height();
      }, function() {
        setCoverImage();
      });

      // If coverImage changes, or mode is no longer 'editor', rescale the cover image.
      scope.$watchGroup([
        'compositeViewCtrl.compositeUnit.coverImage.url',
        'compositeViewCtrl.compositeUnit.coverImage.width',
        'compositeViewCtrl.compositeUnit.coverImage.height',
        'compositeViewCtrl.mode'], function(newValues) {

        var headerContent = jQuery('.bulb-unit-header');
        var noImage = !newValues[0];
        var mode = newValues[3];

        if (noImage) {
          headerContent.removeClass('bulb-has-cover-image');
        } else if (mode !== 'editor') {
          // Either something about the image changed, or mode is no longer 'editor': rescale the image.
          headerContent.addClass('bulb-has-cover-image');
          coverImage = compositeViewCtrl.compositeUnit.coverImage;
          setCoverImage();
        }
      });

      // When imageEditor becomes active, set the height of the mock content wrapper.
      scope.$watch('compositeViewCtrl.isImageEditorActive', function(isImageEditorActive) {
        if (isImageEditorActive) {
          setEditorContent();
        }
      });
    }
  };
}
